import React, { Component } from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import * as firebase from 'firebase';
import flamelink from 'flamelink';

import './App.css';

import Home from './Component/Home';
import Navigation from './Component/Navigation';
import Plugins from './Component/Plugins';
import IfsEditor from './Component/IfsEditor';
import GLFraksl from './Component/GLFraksl';
import Bookmarkemoji from './Component/Bookmarkemoji';
import FooterBar from './Component/FooterBar';
import ErrorPage404 from './Component/ErrorPage404';

class App extends Component {
  constructor(props)
  {
    super(props);
    //init firebase
    let firebaseApp = firebase.initializeApp({
      apiKey: "AIzaSyBnzKd9clLzT3q27HsYrqDBmbEG4nqerOE",
      authDomain: "bezo97-website.firebaseapp.com",
      databaseURL: "https://bezo97-website.firebaseio.com",
      projectId: "bezo97-website",
      storageBucket: "bezo97-website.appspot.com",
      messagingSenderId: "821642475232"
    });
    this.flamelinkApp = flamelink({firebaseApp});
  }
  render() {
    return (
        <main>
          <Navigation/>
          <Switch>
            <Route exact path='/' component={()=> <Home fl={this.flamelinkApp}/> }/>
            <Route exact path='/plugins' component={()=> <Plugins fl={this.flamelinkApp}/> }/>
            <Route exact path='/plugins/development' component={()=> <Plugins fl={this.flamelinkApp}/> }/>
            <Redirect from="/plugins.html" to="/plugins"/>
            <Route exact path='/ifs_editor' component={()=> <IfsEditor/>} />
            <Route exact path='/glFraksl' component={()=> <GLFraksl/>} />
            <Route exact path='/bookmarkemoji' component={()=> <Bookmarkemoji/>} />
            <Route component={ErrorPage404} />
          </Switch>
          <FooterBar/>
        </main>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js